export * from './isLandscape';
export * from './isPortrait';
export * from './isPortraitUpsidedown';
//# sourceMappingURL=index.js.map